import { useQuery } from '@tanstack/react-query';
import ApiService from 'src/services/ApiService';

export const useTenantChecklistById = (checklistId: string) => {
  return useQuery({
    queryKey: ['/tenant/checklist', checklistId] as const,
    queryFn: ApiService.checklist.getTenantChecklistById,
    enabled: !!checklistId,
  });
};
